if (!customElements.get('collection-card-swatches')) {
  class CollectionCardSwatches extends HTMLElement {
    connectedCallback() {
      this.card = this.closest('[data-card-swatches]') || this;
      this.swatches = [...this.card.querySelectorAll('[data-card-swatch]')];
      if (!this.swatches.length) return;

      this.linkTargets = [...this.card.querySelectorAll('[data-card-link]')];
      this.primaryImage = this.card.querySelector('[data-card-primary-image]');
      this.price = this.card.querySelector('[data-card-price]');
      this.variantInput = this.card.querySelector('[data-card-variant-input]');
      this.addButton = this.card.querySelector('[data-card-add-button]');

      this.swatches.forEach((swatch) => {
        swatch.addEventListener('click', (event) => {
          event.preventDefault();
          this.applySwatch(swatch);
        });
      });
    }

    applySwatch(swatch) {
      this.swatches.forEach((item) => {
        const active = item === swatch;
        item.classList.toggle('is-active', active);
        if (active) item.setAttribute('aria-current', 'true');
        else item.removeAttribute('aria-current');
      });

      const variantUrl = swatch.dataset.variantUrl;
      if (variantUrl) {
        this.linkTargets.forEach((link) => {
          link.href = variantUrl;
        });
      }

      if (this.primaryImage) {
        if (swatch.dataset.mediaSrc) this.primaryImage.src = swatch.dataset.mediaSrc;
        if (swatch.dataset.mediaSrcset) this.primaryImage.srcset = swatch.dataset.mediaSrcset;
        if (swatch.dataset.mediaAlt) this.primaryImage.alt = swatch.dataset.mediaAlt;
        if (swatch.dataset.mediaWidth) this.primaryImage.width = Number(swatch.dataset.mediaWidth);
        if (swatch.dataset.mediaHeight) this.primaryImage.height = Number(swatch.dataset.mediaHeight);
      }

      if (this.price && swatch.dataset.priceHtml) {
        this.price.innerHTML = swatch.dataset.priceHtml;
      }

      if (this.variantInput && swatch.dataset.variantId) {
        this.variantInput.value = swatch.dataset.variantId;
        if (swatch.dataset.available === 'true') this.variantInput.removeAttribute('disabled');
        else this.variantInput.setAttribute('disabled', 'disabled');
      }

      if (this.addButton) {
        const available = swatch.dataset.available === 'true';
        this.addButton.disabled = !available;
        const label = this.addButton.querySelector('span');
        if (label) label.textContent = available ? 'Add to cart' : 'Sold out';
      }
    }
  }

  customElements.define('collection-card-swatches', CollectionCardSwatches);
}

document.querySelectorAll('[data-card-swatches]').forEach((card) => {
  if (card.dataset.cardSwatchesBound === 'true') return;
  card.dataset.cardSwatchesBound = 'true';
  const controller = document.createElement('collection-card-swatches');
  card.appendChild(controller);
});
